var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboxesEmptyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 109,
    viewBox: "0 0 165 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_94_22012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Letter_Tray_black"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.497 109L0 53.9143L0.850754 42.6536L56.4642 12.1868L109.276 100.221L102.497 109Z",
    fill: "#ADBEC2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M151.157 80.8575L146.066 79.7879V79.0378L151.157 80.1074V80.8575Z",
    fill: "#0075C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M146.066 79.7879L116.66 96.804L116.313 96.2484L146.066 79.0378V79.7879Z",
    fill: "#0075C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M156.844 50.5898L165 64.0776L164.32 64.4665L156.164 50.9787L156.844 50.5898Z",
    fill: "#0151A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M164.32 73.2455L151.157 80.8576V80.1075L164.32 72.4954V64.4666L165 64.0776V72.8565L164.32 73.2455Z",
    fill: "#0075C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M118.158 99.1932L103.149 107.875C103.149 107.898 103.149 108.227 103.149 108.625L118.162 99.9433V99.1932H118.158Z",
    fill: "#0075C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M118.158 99.1932L103.149 107.875V99.846L94.993 86.3443L22.6836 44.5473L69.3317 17.5717L164.32 72.4953L151.157 80.1074L146.066 79.0378L116.313 96.2483L116.66 96.804L118.158 99.1932Z",
    fill: "#2E8ED3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M164.321 64.4665V72.4953L69.332 17.5717V0.763977L156.164 50.9787L164.321 64.4665Z",
    fill: "#0151A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M156.844 50.5898L69.3595 0L69.3364 0.763986L156.164 50.9787L156.844 50.5898Z",
    fill: "#0151A3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M69.3317 0.763977V17.5717L22.6836 44.5473L8.16064 36.1435L69.3317 0.763977Z",
    fill: "#0163B8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M69.3319 0.763986H69.3365L69.3596 0L6.85693 36.1435H8.16081L69.3319 0.763986Z",
    fill: "#0163B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_12",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.965 101.999C103.311 101.883 158.462 69.2033 158.462 69.2033L156.164 61.2162L141.628 51.6038L103.427 89.4373L102.035 98.6237L102.965 101.999Z",
    fill: "#DDDCDA"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M15.1377 44.7881L92.7782 89.6781L92.2835 89.9652L13.7876 44.5798L15.1377 43.8019V43.8158V44.7881Z",
    fill: "#FEFFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M95.1598 95.0723L148.702 64.1147L149.173 64.3878L93.6663 96.4753L15.1704 51.0899L17.1262 49.9601H17.1355L17.1493 49.9693L95.1598 95.0723Z",
    fill: "#FEFFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M149.141 58.0861V57.8731V57.8222L150.666 58.7019L95.1594 90.794L93.8647 90.0393L149.141 58.0861Z",
    fill: "#FEFFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M92.2837 90.5717V89.9652L92.7784 89.6781L93.3101 89.9883L92.2837 90.5717Z",
    fill: "#DDDCDA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M149.141 57.8731V58.0861L93.865 90.0393L93.6338 90.1735V88.0297L149.141 55.947V57.8222V57.8731Z",
    fill: "#DDDCDA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M149.058 63.9063L149.035 63.9248L148.702 64.1146L95.1597 95.0723V90.794L150.667 58.7019V62.9849L149.062 63.9063H149.058Z",
    fill: "#DDDCDA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M149.173 64.9759V65.6102L94.5399 97.1929L93.666 97.7022V96.4752L149.173 64.3878V64.9759Z",
    fill: "#DDDCDA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M149.173 65.6102V64.9759L150.038 64.4712V71.0183L94.54 103.101V97.193L149.173 65.6102Z",
    fill: "#DDDCDA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M94.5399 97.1929V103.101L16.0439 57.7203V52.8215L16.0578 52.8262L93.666 97.7022L94.5399 97.1929Z",
    fill: "#E8E8E8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M93.6663 96.4753V97.7023L16.0582 52.8262L16.0443 52.8215L15.1704 52.3169V51.0898L93.6663 96.4753Z",
    fill: "#E8E8E8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M93.6337 90.1735L93.8649 90.0393L95.1595 90.794V95.0723L17.1491 49.9693L17.1352 49.9601L16.6636 49.6869V46.8532H16.6682L92.2836 90.5717L93.31 89.9883L93.6337 90.1735Z",
    fill: "#E8E8E8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M92.2835 89.9652V90.5717L16.6681 46.8532H16.6635L13.7876 45.191V44.5798L92.2835 89.9652Z",
    fill: "#E8E8E8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M93.6336 88.0297V90.1735L93.31 89.9883L92.7782 89.6781L15.1377 44.7881V43.8157V43.8019V42.6536L93.6336 88.0297Z",
    fill: "#E8E8E8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M149.141 55.9469L93.6336 88.0297L15.1377 42.6536L70.6448 10.5615L149.141 55.9469Z",
    fill: "#FEFFFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M102.497 100.221L94.3413 86.7194L94.9932 86.3444L103.149 99.8461L102.497 100.221Z",
    fill: "#01337F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M103.149 99.8461L102.498 100.221V109L103.145 108.625C103.145 108.227 103.145 107.898 103.145 107.875V99.8461H103.149Z",
    fill: "#0075C9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M102.497 100.221V109L6.85693 53.7013V36.1435L94.3412 86.7194L102.497 100.221Z",
    fill: "#01337F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M22.6837 44.5473L8.16081 36.1435H6.85693L94.3412 86.7194L94.9932 86.3443L22.6837 44.5473Z",
    fill: "#01337F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M149.173 64.9759L150.038 64.4712L149.058 63.9063L148.702 64.1147L149.173 64.3879V64.9759Z",
    fill: "#C1C2C2"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_22012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 109,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxesEmptyIcon);
export default __webpack_public_path__ + "static/media/inboxes-empty-icon.c6410c03b79ee45220ac4b4b58a0428f.svg";
export { ForwardRef as ReactComponent };